/** ч.1425: переписка відвідувача за посиланням з листа (без входу). */
import { api } from '@/api/client';

export interface FeedbackMessage {
  author_kind: 'user' | 'agent' | 'staff';
  body: string;
  created_at: string;
}

export interface FeedbackThread {
  public_id: string;
  title: string;
  status: string;
  messages: FeedbackMessage[];
}

export const feedback = {
  thread: (token: string) =>
    api.get<FeedbackThread>(`/help/feedback/${token}`, { headers: { 'X-Silent-Toast': '1' } }).then((r) => r.data),
  send: (token: string, body: string) =>
    api.post<FeedbackThread>(`/help/feedback/${token}/messages`, { body }).then((r) => r.data),
};
